import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { HelpArticleCreatePage, helpCategoriesQueryOptions } from '@/features/help-center';

export const Route = createFileRoute('/_authed/_active/s/$storeId/help/new')({
  staticData: { crumb: 'helpCenter:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'help.write');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...helpCategoriesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: HelpArticleCreatePage,
});
